import { LogOut, RefreshCw } from "lucide-react";
import { GlobeMark } from "@/components/site/Logo";

export const InboxHeader = ({ onRefresh, onLogout }) => (
  <header className="bg-[#082F24] text-[#FAF8F5]">
    <div className="mx-auto max-w-7xl px-5 py-4 flex items-center justify-between">
      <div className="flex items-center gap-3"><GlobeMark className="h-8 w-8" /><span data-testid="admin-inbox-title" className="font-display text-2xl">Enquiry inbox</span></div>
      <div className="flex gap-2">
        <button data-testid="admin-refresh-btn" onClick={onRefresh} aria-label="Refresh" className="grid h-10 w-10 place-items-center rounded-full border border-[#FAF8F5]/25 hover:bg-[#FAF8F5]/10"><RefreshCw className="h-4 w-4" /></button>
        <button data-testid="admin-logout-btn" onClick={onLogout} aria-label="Sign out" className="inline-flex items-center gap-2 rounded-full bg-[#D4AF37] px-4 text-sm font-semibold text-[#082F24]"><LogOut className="h-4 w-4" /><span className="hidden sm:inline">Sign out</span></button>
      </div>
    </div>
  </header>
);